import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import LogoWithText from "../assets/images/logowithtext.png";
import "../style/paymentresult.css";

const PaymentSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const orderId = searchParams.get("order_id");
  const transactionStatus = searchParams.get("transaction_status");

  // Saat user menutup popup Snap (klik X) tanpa menyelesaikan pembayaran,
  // Midtrans tetap redirect ke finish URL dengan transaction_status=cancel
  // atau tanpa params sama sekali. Handle case ini secara eksplisit supaya
  // tidak tampil sebagai "Payment Successful".
  const isCancelled = !transactionStatus || transactionStatus === "cancel";
  const isPending = !isCancelled && transactionStatus === "pending";

  const icon = isCancelled
    ? "bi-x-circle-fill"
    : isPending ? "bi-hourglass-split" : "bi-check-circle-fill";
  const iconColor = isCancelled ? "#6c757d" : isPending ? "#d97706" : "#16a34a";
  const iconBg = isCancelled ? "#f8f9fa" : isPending ? "#fff8e1" : "#e6f9ee";
  const title = isCancelled
    ? "Payment Not Completed"
    : isPending ? "Payment Received — Awaiting Confirmation" : "Payment Successful!";
  const description = isCancelled
    ? "It looks like the payment window was closed before payment was completed. No charges have been made. You can return to the homepage and try registering again."
    : isPending
    ? "We've received your payment details and are waiting for it to be confirmed by the bank/payment provider. This usually takes just a few minutes."
    : "Thank you! Your payment has been received and is being processed.";

  return (
    <div className="custom-payment-result-page">
      <img src={LogoWithText} alt="Cutting Edge Academy" className="custom-payment-logo" />

      <div className="custom-payment-icon" style={{ backgroundColor: iconBg }}>
        <i className={`bi ${icon}`} style={{ color: iconColor }}></i>
      </div>

      <h1 className="custom-payment-title">{title}</h1>

      <p className="custom-payment-desc">{description}</p>
      <p className="custom-payment-desc">
        You will receive a confirmation email once your registration is fully finalized. You may safely close this page.
      </p>

      {orderId && (
        <div className="custom-payment-detail-box">
          <div className="custom-payment-detail-row">
            <span className="custom-payment-detail-label">Order ID</span>
            <span className="custom-payment-detail-value">{orderId}</span>
          </div>
        </div>
      )}

      <div className="custom-payment-actions" style={{ display: "flex" }}>
        <button
          className="custom-payment-btn custom-payment-btn-primary"
          onClick={() => navigate("/")}
          style={{ border: "none", cursor: "pointer" }}
        >
          Back to Homepage
        </button>
        <a
          href="https://wa.me/628984001333"
          target="_blank"
          rel="noopener noreferrer"
          className="custom-payment-btn custom-payment-btn-secondary"
        >
          Contact Us
        </a>
      </div>

      <p className="custom-payment-footer">
        &copy; {new Date().getFullYear()} Cutting Edge Academy. All rights reserved.
      </p>
    </div>
  );
};

export default PaymentSuccessPage;
